import { OnOffSwitchService } from "../Common/OnOffSwitchConfigurations/OnOffSwitchService";
export class RomConfigService extends OnOffSwitchService {
    constructor() {
        super();
    }
    GetServiceName() {
        return RomConfigService.ServiceName;
    }
}
RomConfigService.ServiceName = "RomConfigService";
//# sourceMappingURL=RomConfigService.js.map